export default __webpack_public_path__ + "static/media/baysel4.a2bb2707.png";